export type FormMetricsLegendDisplay = {
  mode: 'icon' | 'text';
  iconName?: string;
  text: string;
  ariaLabel: string;
};

export type FormMetricsLegendItem = {
  color: string;
  display: FormMetricsLegendDisplay;
};

/**
 * Standby: legenda HTML custom (Feather). Desligada para priorizar a API nativa do Apex
 * (toggle/ações futuras). Religar quando ícones na legenda forem obrigatórios.
 */
export const USE_CUSTOM_CHART_LEGEND = false;

export function resolveLegendDisplay(input: {
  label?: string | null;
  iconName?: string | null;
  valueFallback?: string | number | null;
}): FormMetricsLegendDisplay {
  const trimmedLabel = input.label?.trim() || '';
  const fallback =
    input.valueFallback === null || input.valueFallback === undefined
      ? ''
      : String(input.valueFallback);
  const text = trimmedLabel || fallback;
  const trimmedIcon = input.iconName?.trim() || '';

  if (trimmedIcon) {
    return {
      mode: 'icon',
      iconName: trimmedIcon,
      text,
      ariaLabel: text,
    };
  }

  return {
    mode: 'text',
    text,
    ariaLabel: text,
  };
}

export function hasAnyLegendIcon(
  items: Array<{ iconName?: string | null }>
): boolean {
  return items.some(item => !!item.iconName?.trim());
}
